import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconArrowRoundAntiClockwise16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconArrowRoundAntiClockwise16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M3.78 6.86C4.414 4.495 6.73 3.165 9.1 3.8c2.367.634 3.708 2.958 3.074 5.327s-2.96 3.71-5.326 3.076a4.45 4.45 0 0 1-1.73-.892 3.6 3.6 0 0 1-.495-.509l-.019-.026-.003-.003.001.001v-.002a.5.5 0 0 0-.831.557l.395-.263-.395.264v.001l.002.002.004.005.01.016a2 2 0 0 0 .17.213c.115.134.285.313.514.507a5.45 5.45 0 0 0 2.118 1.095c2.901.777 5.773-.882 6.55-3.783.778-2.902-.88-5.775-3.78-6.552-2.706-.725-5.385.657-6.362 3.205V3.945a.5.5 0 1 0-1 0v4h4a.5.5 0 1 0 0-1H3.749a.5.5 0 0 0 .03-.085"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconArrowRoundAntiClockwise16);
